module.exports = __webpack_public_path__ + "static/media/budget-no-data.a93e5a6e.jpg";